import messages from '../../messages';

export const VALID_USERNAME_REGEX = /^[a-zA-Z0-9_-]*$/i;
export const usernameRegex = new RegExp(VALID_USERNAME_REGEX, 'i');

const USERNAME_MIN_LENGTH = 2;
const USERNAME_MAX_LENGTH = 150;

const validateUsername = (value, formatMessage) => {
  let fieldError = '';

  if (
    !value ||
    value.length < USERNAME_MIN_LENGTH ||
    value.length > USERNAME_MAX_LENGTH
  ) {
    fieldError = formatMessage(messages['username.validation.message']);
  } else if (!usernameRegex.test(value)) {
    fieldError = formatMessage(messages['username.format.validation.message']);
  }

  return fieldError;
};

export default validateUsername;

